// @ts-nocheck
import useScrollContext from "@store/Framework/Common/Hooks/useScrollContext";

export default () => {
    const { scroll } = useScrollContext();

    return scroll < 1;
};
